


const getCapitalizedString = (string?: string) => { 

    if (string) { 

        return String(string).charAt(0).toUpperCase() + String(string).slice(1);
    }; 

}; 

export default getCapitalizedString;